import { getParent, findAll, find } from "@kluntje/js-utils/lib/dom-helpers";
/**
 * tracking clicks on anchors or search form and push the data
 * to a static datalayer array of objects on the window object
 * (Place the datalayer in the head between a script tag)
 */
export class GoogleTagManager {
  static _instance: GoogleTagManager;
  constructor() {
    this.init();
  }

  /**
   * initialize plugin
   */

  static getInstance(): GoogleTagManager {
    // no instance yet
    if (!GoogleTagManager._instance) {
      GoogleTagManager._instance = new GoogleTagManager();
    }
    return GoogleTagManager._instance;
  }

  /**
   * Initialize the plugin for anchors link
   * Use it with this markup:
   *
   * <a href="http://" title="My title" data-gatracking='{"event":"gaEvent","eventCategory":"Quicklink"}'>My test tracking link</a>
   *
   * OR
   *
   * <a href="http://" title="My title" data-gaanalytics='{"event":"gaEvent","eventCategory":"Quicklink"}'>My test gaanalytics</a>
   *
   * OR
   *
   * <div data-gaanalytics='{"event":"gaEvent","eventCategory":"Quicklink"}'>
   *  <div> <-- also with more html tag between
   *    <a href="http://" title="My title">My test gaanalytics</a>
   *  </div>
   * </div>
   *
   * OR
   *
   * <div data-gatracking='{"event":"gaEvent","eventCategory":"Quicklink"}'>
   *  <div>
   *    <a href="http://" title="My title">My test gaanalytics</a>
   *  </div>
   * </div>
   */

  init() {
    document.addEventListener("click", (e: Event) => {
      const element = e.target as HTMLLinkElement;
      // eject if google analytics SDK is not present
      if (!window.dataLayer) return;
      let data;
      /**
       * get the event data for the anchor
       * sometimes is the data attribute on the anchor,
       * sometimes on an ancestordata attribute is sometime named `data-gaanalytics` amd some times `data-gatracking`
       */
      if (element.hasAttribute("data-gaanalytics") || element.hasAttribute("data-gatracking")) {
        // Get data from data-gaanalitycs attribute
        data = element.getAttribute("data-gaanalytics") || element.getAttribute("data-gatracking");
      } else if (element && getParent(element, "[data-gaanalytics]")) {
        // or get data from the parent data-gaanalitycs attribute
        data = getParent(element, "[data-gaanalytics]")!.getAttribute("data-gaanalytics");
      } else if (element && getParent(element, "[data-gatracking]")) {
        // or get data from data-gatracking attribute
        data = getParent(element, "[data-gatracking]")!.getAttribute("data-gatracking");
      } else {
        return;
      }
      if (typeof data === "string") {
        // prepare the data for pushing it to the dataLayer object
        data = JSON.parse(data);
      }
      if (data !== null) {
        // add eventLabel property to the dataLayer object
        if (!data.eventLabel || /^\s*$/.test(data.eventLabel)) {
          const link = find(element, "a[href^=http]") as HTMLElement;
          data.eventLabel = element.getAttribute("href") || element.getAttribute("title") || "";
          if (link) data.eventLabel = link.getAttribute("href") || "";
        }
        // add eventAction property to the dataLayer object
        if (!data.eventAction || /^\s*$/.test(data.eventAction)) {
          const link = find(element, "a[href^=http]") as HTMLElement;
          data.eventAction = element.getAttribute("title") || "";
          if (link) data.eventAction = link.getAttribute("title") || "";
        }
      } else {
        return;
      }
      // fill the trackerobeject string
      window.trackerobject.gaEvent = `${data.eventCategory}|${data.eventAction}|${data.eventLabel}`;
      // push data to the dataLayer object
      window.dataLayer.push(data);
    });

    /**
     * Initialize the plugin for the search form
     */
    findAll(document.body, ".fra-m-search__form").forEach((element: HTMLFormElement) => {
      element.addEventListener("submit", function () {
        // eject if google analytics SDK is not present
        if (!window.dataLayer) return;
        const inputValue = (find(element, "input") as HTMLInputElement).value;
        const datalayerObject = {
          event: "gaEvent",
          eventCategory: "Search",
          eventAction: inputValue,
        };
        /**
         * push the search input value as object to the dataLayer object
         */
        window.dataLayer.push(datalayerObject);
      });
    });
  }
}

GoogleTagManager.getInstance();
